import type { CreateTariffInput, UpdateTariffInput } from '@/graphql/generated';
import { TariffTypeEnum } from '@/graphql/generated';
import { ulid } from 'ulid';

export interface TariffFormStepInput {
	tariffStepId?: string;
	stepSequence?: number; // Optional - computed from index if not provided
	intervalMinutes: number;
	intervalCharge: number;
	maxIntervals?: number;
}

export interface TariffFormSubmitData {
	name: string;
	tariffTypeEnum: TariffTypeEnum;
	flatRateAmount?: number;
	tariffSteps?: TariffFormStepInput[];
}

const normaliseFlatRateAmount = (value: number | undefined): number | null => {
	if (value == null || value === 0) {
		return null;
	}

	return value;
};

export const buildCreateTariffInput = (
	formData: TariffFormSubmitData,
	tariffId: string
): CreateTariffInput => {
	const steps = (formData.tariffSteps ?? []).map((step, index) => ({
		tariffStepId: step.tariffStepId ?? ulid(),
		stepSequence: step.stepSequence ?? index + 1,
		intervalMinutes: step.intervalMinutes,
		intervalCharge: step.intervalCharge,
		maxIntervals: step.maxIntervals ?? null
	}));

	return {
		tariffId,
		name: formData.name,
		tariffTypeEnum: formData.tariffTypeEnum,
		flatRateAmount: normaliseFlatRateAmount(formData.flatRateAmount),
		tariffSteps: steps
	};
};

export const buildUpdateTariffInput = (
	formData: TariffFormSubmitData,
	tariffId: string
): UpdateTariffInput => {
	const steps = (formData.tariffSteps ?? []).map((step, index) => ({
		tariffStepId: step.tariffStepId ?? ulid(),
		stepSequence: step.stepSequence ?? index + 1,
		intervalMinutes: step.intervalMinutes,
		intervalCharge: step.intervalCharge,
		maxIntervals: step.maxIntervals ?? null
	}));

	return {
		tariffId,
		name: formData.name,
		tariffTypeEnum: formData.tariffTypeEnum,
		flatRateAmount: normaliseFlatRateAmount(formData.flatRateAmount),
		tariffSteps: steps
	};
};
